
export default function Loader(){


  return (
    <div className="loading" style={{padding: '20px'}}>
      <div className="loading-bar" />
      <div className="loading-bar" />
      <div className="loading-bar" />
      <div className="loading-bar" />
    </div>
  )


}



// WEBPACK FOOTER //
// ./components/util/loader.js